import { render, staticRenderFns } from "./ItemsMonitor.vue?vue&type=template&id=372bf0e3&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ItemsMonitor.vue?vue&type=script&lang=ts"
export * from "./ItemsMonitor.vue?vue&type=script&lang=ts"
import style0 from "./ItemsMonitor.vue?vue&type=style&index=0&id=372bf0e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372bf0e3",
  null
  
)

export default component.exports